<template>
  <div class="grid"
       :style="customGridStyle">

    <app-question :data-heading="interaction.descricao"
                  :data-color=" interactionColor"></app-question>

    <div class="grid-center slider-wrapper" ref="gauge" id="gaugePreview">

    </div>

    <div class="grid-bottom text-center">
      <button class="btn btn-stretch btn-extra-round text-bold"
              :class="{'btn-extended-description' : hasExtendedDescription}"
              :style="buttonStyle(interaction.opcoes[0].estilo)"
              @click="$emit('next', sliderValue)">
        {{interaction.opcoes[0].nome}}
      </button>
    </div>
  </div>
</template>

<script>
    import AppQuestion from './Question'
    import buttonStyle from '../../../../interactions/components/interaction/mixins/button-style';
    import dataInteractionProp from '../mixins/data-interaction-prop'
    // import Echarts from 'vue-echarts'
    import * as echarts from 'echarts'
    import {SVGRenderer} from "echarts/renderers";

    // Vue.component('chart', Echarts)
    echarts.use(SVGRenderer)

    export default {
        components: {
            AppQuestion,
        },

        data() {
            return {
                sliderValue: 8,
                gaugeOptions: {
                    series: [
                        {
                            triggerEvent: true,
                            name: "gauge",
                            silent: false,
                            type: "gauge",
                            startAngle: 220,
                            endAngle: -40,
                            center: ["50%", "55%"],
                            radius: "85%",
                            min: 0,
                            max: 1.1,
                            splitNumber: 11,
                            axisLine: {
                                roundCap: false,
                                borderWidth: 5,
                                lineStyle: {
                                    width: 40,
                                    color: [
                                        [0.1, "red"],
                                        [0.2, "red"],
                                        [0.3, "red"],
                                        [0.4, "red"],
                                        [0.5, "red"],
                                        [0.635, "red"],
                                        [0.7, "orange"],
                                        [0.82, "orange"],
                                        [0.9, "green"],
                                        [1, "green"],
                                    ],
                                },
                            },
                            pointer: {
                                show: false,
                                icon: "path://M12.8,0.7l12,40.1H0.7L12.8,0.7z",
                                length: "12%",
                                width: 20,
                                offsetCenter: ["10%", "-60%"],
                                itemStyle: {
                                    color: "green",
                                },
                            },
                            axisTick: {
                                show: false,
                                length: 12,
                                lineStyle: {
                                    color: "inherit",
                                    width: 2,
                                },
                            },
                            splitLine: {
                                distance: -40,
                                triggerEvent: true,
                                show: true,
                                length: 40,
                                lineStyle: {
                                    color: "#fff",
                                    width: 1,
                                },
                            },
                            axisLabel: {
                                padding: [0, 0, 0, 45],
                                color: "#fff",
                                fontSize: 18,
                                distance: 22,
                                rotate: "tangential",
                                formatter: function (value) {
                                    switch (value) {
                                        case 0:
                                            return "0";
                                        case 0.1:
                                            return "1";
                                        case 0.2:
                                            return "2";
                                        case 0.3:
                                            return "3";
                                        case 0.4:
                                            return "4";
                                        case 0.5:
                                            return "5";
                                        case 0.6:
                                            return "6";
                                        case 0.7:
                                            return "7";
                                        case 0.8:
                                            return "8";
                                        case 0.9:
                                            return "9";
                                        case 1:
                                            return "10";
                                        case 1.1:
                                            return " ";
                                    }
                                },
                            },
                            title: {
                                offsetCenter: [0, "-10%"],
                                fontSize: 20,
                                show: false,
                            },
                            detail: {
                                fontSize: 62,
                                offsetCenter: [0, "-5%"],
                                valueAnimation: true,
                                formatter: function (value) {
                                    return Math.round(value * 10) + "";
                                },
                                color: "inherit",
                            },
                            data: [
                                {
                                    value: this.setGaugeValue(),
                                    name: "Nota",
                                },
                            ]
                        }
                    ]
                }
            }
        },

        computed: {
            interactionColor() {
                return this.interaction.estilo ? 
                this.interaction.estilo.question.color : 
                {
                    r: "112",
                    g: "112",
                    b: "112",
                    a: "1"    
                }
            },
            hasExtendedDescription() {
                return this.dataInteraction.descricao.length > 60
            },
            customGridStyle() {
                return this.hasExtendedDescription ?
                {
                    "grid-template-rows": "195px 3fr 1fr !important"
                } :
                ""
            },            
        },

        methods: {
            initEcharts() {
                let newPromise = new Promise((resolve) => {
                    resolve()
                })

                newPromise.then(() => {

                    let chart = echarts.init(this.$refs.gauge, null, {
                        renderer: "svg",
                    });
                    chart.setOption(this.gaugeOptions);

                    const paths = document.getElementsByTagName("path");
                    let pathsArray = Array.from(paths);
                    pathsArray.map((path, i) => {
                        if(i < 2 ) {
                            path.style.stroke = "green"
                        } else if (i >= 2 && i < 4 ) {
                            path.style.stroke = "orange"
                        } else if (i >= 4 && i < 10) {
                            path.style.stroke = "red"
                        }
                    })

                    const texts = document.querySelector("#gaugePreview").querySelectorAll("text")
                    let textsArray = Array.from(texts);
                    textsArray.map((text, i) => (text.id = i));
                    textsArray.map((text, i) => {
                        if(i > 10) {
                            return
                        }
                        text.innerHTML = `&nbsp ${i} &nbsp`;
                        text.style.cursor = 'pointer'
                    })

                    textsArray[0].addEventListener("click", this.setGaugeValue);
                    textsArray[1].addEventListener("click", this.setGaugeValue);
                    textsArray[2].addEventListener("click", this.setGaugeValue);
                    textsArray[3].addEventListener("click", this.setGaugeValue);
                    textsArray[4].addEventListener("click", this.setGaugeValue);
                    textsArray[5].addEventListener("click", this.setGaugeValue);
                    textsArray[6].addEventListener("click", this.setGaugeValue);
                    textsArray[7].addEventListener("click", this.setGaugeValue);
                    textsArray[8].addEventListener("click", this.setGaugeValue);
                    textsArray[9].addEventListener("click", this.setGaugeValue);
                    textsArray[10].addEventListener("click", this.setGaugeValue);
                })
            },

            setGaugeValue(e) {
                let text = document.getElementById('12');
                if (e === undefined) {
                    return 1;
                }

                text.innerHTML = e.target.id;

                if (e.target.id < 7) {
                    text.setAttribute("fill", "red");
                } else if (e.target.id > 8) {
                    text.setAttribute("fill", "green");
                } else {
                    text.setAttribute("fill", "orange");
                }
            }
        },

        mounted() {
            this.initEcharts();
        },

        mixins: [buttonStyle, dataInteractionProp]
    }
</script>

<style lang="scss" scoped>

.grid {
    .grid-bottom {
        .btn-extended-description {
            position: relative;
            bottom: 25px;
        }
    }
}
.slider-wrapper {
  margin: auto;
}

#gaugePreview {
    width: 337px;
    height: 300px;
}

.btn {
  border: 1px solid transparent;
  font-size: 14px;
  min-width: 40%;
  max-width: 65%;
}
</style>
